// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { ApierrorsError, ResponseRegionList } from '../models/index';
import {
  ApierrorsErrorFromJSON,
  ApierrorsErrorToJSON,
  ResponseRegionListFromJSON,
  ResponseRegionListToJSON,
} from '../models/index';

/**
 *
 */
export class RegionApi extends runtime.BaseAPI {
  /**
   * List regions
   * List regions
   */
  async v3RegionsGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseRegionList>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/v3/regions`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseRegionListFromJSON(jsonValue),
    );
  }

  /**
   * List regions
   * List regions
   */
  async v3RegionsGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseRegionList> {
    const response = await this.v3RegionsGetRaw(initOverrides);
    return await response.value();
  }
}
